import { type IPrivateContact } from '@inpart-io/padme-iap';
import { type MutationTree } from 'vuex';

import { type IPrivateContactState } from './types';

export const SET_MATCHES = 'SET_MATCHES';

export const mutations: MutationTree<IPrivateContactState> = {
    [SET_MATCHES](_state, { contactId, matches }: { contactId: number; matches: IPrivateContact[] }) {
        _state.matches.set(contactId, matches);
    }
};
